import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'md',
  },
  theme: {
    dark: true,
    themes: {
      dark: {
        primary: '#cc3333',
        secondary: '#212121',
        error: '#cc3333',
        green: '#23D160',
        cyan: '#01A49C',
      },
    },
  },
});
